import React, { ReactElement } from 'react'

export const Layout2Top3Bottom: React.FC = (): ReactElement => (
    <div className='layout2Top3Bottom'>
        <svg viewBox='0 0 30 30'>
            <path className='dashboard-layout-outer-border' d='M28,2V28H2V2H28m2-2H0V30H30V0Z' />
            <line className='central-border-line' y1='15' x2='30' y2='15' />
            <rect
                className='dashboard-background-3 dashboard-layout-entry-square'
                x='1.99'
                y='16'
                width='8.01'
                height='12'
            />
            <text
                className='dashboard-foreground-3 dashboard-layout-entry-text'
                transform='translate(4.06 24.69) scale(0.94 1)'
            >
                3
            </text>
            <rect
                className='dashboard-background-4 dashboard-layout-entry-square'
                x='11.49'
                y='16'
                width='7.8'
                height='12'
            />
            <text
                className='dashboard-foreground-4 dashboard-layout-entry-text'
                transform='translate(13.58 24.69) scale(0.94 1)'
            >
                4
            </text>
            <rect
                className='dashboard-background-5 dashboard-layout-entry-square'
                x='21'
                y='16'
                width='7.29'
                height='12'
            />
            <text
                className='dashboard-foreground-5 dashboard-layout-entry-text'
                transform='translate(23.08 24.67) scale(0.94 1)'
            >
                5
            </text>
            <line className='central-border-line' x1='10.5' y1='14' x2='10.5' y2='29' />
            <line className='central-border-line' x1='20.2' y1='14' x2='20.2' y2='29' />
            <line className='central-border-line' x1='15' x2='15' y2='14' />
            <rect className='dashboard-background-1 dashboard-layout-entry-square' x='2' y='2' width='12' height='12' />
            <text className='dashboard-foreground-1 dashboard-layout-entry-text' transform='translate(6.64 10.74)'>
                1
            </text>
            <rect
                className='dashboard-background-2 dashboard-layout-entry-square'
                x='16'
                y='2'
                width='12'
                height='12'
            />
            <text className='dashboard-foreground-2 dashboard-layout-entry-text' transform='translate(20.2 10.74)'>
                2
            </text>
        </svg>
    </div>
)
